import loadFeatureToggle from '@/feature-toggle';
import { parseConfig } from './root-app/util/config';
import { initializeTenantSelection } from './tenant-selection';

window.addEventListener('DOMContentLoaded', async () => {
  const configImport = await import(
    /* webpackChunkName: "config" */ './root-app/config'
  );

  const config = parseConfig(configImport.config);

  const featureToggle = await loadFeatureToggle(config.rootPath);

  const configWithFeatureToggle = {
    ...config,
    featureToggle: {
      ...config.featureToggle,
      ...featureToggle,
    },
  };

  const tenantResult = initializeTenantSelection(
    configWithFeatureToggle.tenant,
    configWithFeatureToggle.featureToggle?.loginScreenEnabled === false,
  );
  if (tenantResult === null) {
    // Invalid Tenant. User will redirect to the tenant selection screen
    return;
  }

  const rootAppImport = await import(
    /* webpackChunkName: "root-app" */ './root-app'
  );

  const rootApp = new rootAppImport.RootApp(
    configWithFeatureToggle,
    tenantResult.tenant,
  );

  window.api = rootApp;
});
